export default __webpack_public_path__ + "static/media/data_poster.ad7e2814.svg";